module.exports = __webpack_public_path__ + "img/西瓜15.0fe876ef.png";